import { createContext, useContext } from 'react';

/**
 * 画面遷移履歴を保持するContext
 * アプリ全体の画面遷移履歴を配列で管理し、
 * 「前の画面からの遷移先制御」や「リロード検知」に利用する。
 * 配列の先頭要素（history[0]）が直前の遷移元パスを表す。
 */
const historyContext = createContext<string[]>(['', '']);

/**
 * 遷移情報に関連するフック処理を実施する
 */
export const useHistoryContext = () => {
  // 遷移情報のフック
  const history = useContext(historyContext);

  /**
   * 最新の遷移元情報を取得する
   * @returns 遷移元情報
   */
  const getLatestHistory = (): string | undefined => {
    if (history.length <= 0) {
      return undefined;
    }
    // 先頭要素を直前遷移元として扱う前提で共通利用する。
    return history[0];
  };
  return { getLatestHistory };
};

export default historyContext;
